module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAzIiBoZWlnaHQ9IjEzNyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJNOTYuNi43bC03LjcgMTMuNiA2IC4zLS4xLjRjLTUuNyA0OS42LTQwLjYgOTMuNi05MyAxMTlsLTEuNi44LjggMS44QzU1IDExMSA5MSA2NiA5Ni44IDE1LjJ2LS41bDYgLjNMOTYuNy43eiIgZmlsbD0iI0JCQiIgZmlsbC1ydWxlPSJub256ZXJvIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/static/images/mycourses/Arrow.svg
// module id = 1705
// module chunks = 0